module.exports = __webpack_public_path__ + "img/sun.d56e8fa6.svg";